import { render, staticRenderFns } from "./179.vue?vue&type=template&id=2bb64f9d&scoped=true&"
var script = {}
import style0 from "./179.vue?vue&type=style&index=0&id=2bb64f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb64f9d",
  null
  
)

export default component.exports